import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import '../../../../assets/scss/preview.css';
import { ptwFormApi } from '../../../../api/ptwForm.api.ts';
import { QRCodeCanvas, QRCodeSVG } from 'qrcode.react';
import { ciImage } from '../../../../constants';
import PermitIssuePreviewApproval01 from './preview/PermitIssuePreviewApproval01.tsx';
import PermitIssuePreviewClose01 from './preview/PermitIssuePreviewClose01.tsx';
import PermitIssuePreviewApproval02 from './preview/PermitIssuePreviewApproval02.tsx';
import PermitIssuePreviewBase01 from './preview/PermitIssuePreviewBase01.tsx';
import PermitIssuePreviewListUnit from './preview/PermitIssuePreviewListUnit.tsx';
import PermitIssuePreviewBase02 from './preview/PermitIssuePreviewBase02.tsx';
import PermitIssuePreviewListYnnar from './preview/PermitIssuePreviewListYnnar.tsx';
import PermitIssuePreviewApproval03 from './preview/PermitIssuePreviewApproval03.tsx';
import PermitIssuePreviewBase06 from './preview/PermitIssuePreviewBase06.tsx';
import PermitIssuePreviewCheck06 from './preview/PermitIssuePreviewCheck06.tsx';
import PermitIssuePreviewApproval06 from './preview/PermitIssuePreviewApproval06.tsx';
import PermitIssuePreviewBase05 from './preview/PermitIssuePreviewBase05.tsx';
import PermitIssuePreviewApproval07 from './preview/PermitIssuePreviewApproval07.tsx';
import PermitIssuePreviewApproval08 from './preview/PermitIssuePreviewApproval08.tsx';
import PermitIssuePreviewCheck07 from './preview/PermitIssuePreviewCheck07.tsx';
import PermitIssuePreviewCheck08 from './preview/PermitIssuePreviewCheck08.tsx';
import { safObjectHelper } from '../../../../utils/SafObjectHelper.ts';
import { companyApi } from '../../../../modules';
import PermitIssuePreviewBase04 from './preview/PermitIssuePreviewBase04.tsx';

interface IProps {
  ref?: any;
  formCode: string;
  itemData: any;
  approvalStatus: any;
}

const PermitIssuePreview = (props: IProps) => {
  const [formInfo, setFormInfo] = useState<any>({});
  const [signedList, setSignedList] = useState<any[]>([]);
  const [companyName, setCompanyName] = useState<any>();
  useEffect(() => {
    if (!props.itemData?.companyId) return;
    companyApi.getCompanyName({ companyId: props.itemData.companyId }).then((res) => {
      setCompanyName(res.resultObject.companyName);
    });
  }, [props.itemData?.companyId]);
  useEffect(() => {
    if (props.formCode) {
      ptwFormApi.getPtwFormInfo(props.formCode).then((res) => {
        //console.log(res);
        setFormInfo(res.resultObject);
      });
    }
  }, [props.formCode]);
  useEffect(() => {
    //console.log(1212, props.itemData);
  }, [props.itemData]);

  useEffect(() => {
    if (!props.itemData?.ptwMSeq) return;
    ptwFormApi.getSignedUser(props.itemData.ptwMSeq).then((res) => {
      setSignedList(res.resultList ?? []);
    });
  }, [props.itemData?.ptwMSeq]);

  const approvalList = React.useMemo(() => {
    const baseList = props.itemData?.approvalMVOList ?? [];
    if (signedList.length === 0) return baseList;

    return baseList.map((base: any) => {
      const signed = signedList.find(
        (s: any) => s.approvalType === base.approvalType && s.oder === base.oder
      );

      if (!signed) return base;

      return {
        ...base,
        userId: signed.userId,
        userNm: signed.userNm,
        sign: signed.sign,
        signType: signed.signType,
        createDate: signed.createDate
      };
    });
  }, [props.itemData?.approvalMVOList, signedList]);

  // qr코드값
  const baseUrl =
    import.meta.env.VITE_BUILD_MODE === 'production' ? 'https://www.taziz4s.com' : 'https://dev.taziz4s.com';
  const qrValue = `${baseUrl}/ptw/preview/${props.itemData?.ptwNo}`;

  return (
    <div className={'preview-container'}>
      {props.itemData?.ptwNo && (
        <div className={'qr-box'}>
          {props.formCode && (
            <QRCodeCanvas
              value={qrValue} //qr 코드에 들어갈 값
              size={512} //픽셀 크기
              bgColor="#ffffff"
              fgColor="#000000"
              level="H" //오류 복원 (L/M/Q/H)
              style={{
                width: '60px',
                height: '60px'
              }}
              includeMargin={true} // 여백
            />
          )}
        </div>
      )}
      <div className={'preview-box'}>
        <div className={'preview-header'}>
          {formInfo?.caption && (
            <div className={'preview-caption'} style={{ color: formInfo?.color01 }}>
              {formInfo?.caption}
            </div>
          )}
          <div className={'preview-title'} style={{ backgroundColor: formInfo?.color02 }}>
            {formInfo?.logo1Path && (
              <div className={'preview-title-left-logo'}>
                {formInfo.logo1Path.split(';').filter(Boolean).map((path: string, i: number) => (
                  <img key={i} src={path.trim()} />
                ))}
              </div>
            )}
            {formInfo?.title}
            {formInfo?.logo2Path && (
              <div className={'preview-title-right-logo'}>
                {formInfo.logo2Path.split(';').filter(Boolean).map((path: string, i: number) => (
                  <img key={i} src={path.trim()} />
                ))}
              </div>
            )}
          </div>
        </div>
        <div
          className={
            'preview-contents ' +
            (props.approvalStatus === 'CANCEL' ? 'preview-cancel-watermark' : '')
          }
        >
          {(props.formCode === 'CW' || props.formCode === 'HW' || props.formCode === 'SW') && (
            <div className={'preview-row full-width'}>
              <div className={'preview-col preview-label'}>Work Permit No.</div>
              <div className={'preview-col preview-value'}>{props.itemData?.ptwNo}</div>
              <div className={'preview-col preview-label'}>Task Risk Assessment No.</div>
              <div className={'preview-col preview-value'}>{props.itemData?.jhaNo}</div>
              <div className={'preview-col preview-label'}>Method Statement No.</div>
              <div className={'preview-col preview-value'}>{props.itemData?.statementJhaNo}</div>
            </div>
          )}
          {props.formCode === 'RC' && (
            <div className={'preview-row full-width'}>
              <div className={'preview-col preview-label'}>Road Closure Permit No.</div>
              <div className={'preview-col preview-value'}>{props.itemData?.ptwNo}</div>
              <div className={'preview-col preview-label'}>Submitted date</div>
              <div className={'preview-col preview-value'}>
                {safObjectHelper.formatDate(props.itemData?.permitDate)}
              </div>
            </div>
          )}
          {props.formCode === 'LP' && (
            <div className={'preview-row full-width'}>
              <div className={'preview-col preview-label saf-bg-white'}>Company Name: </div>
              <div className={'preview-col preview-value saf-td-center'}>{companyName}</div>
              <div className={'preview-col preview-label saf-bg-white'}>Permit Number : </div>
              <div className={'preview-col preview-value'}>{props.itemData?.ptwNo}</div>
            </div>
          )}
          {props.formCode === 'EC' && (
            <div className={'preview-row full-width'}>
              <div className={'preview-col preview-label saf-bg-white'}>ECC Number</div>
              <div className={'preview-col preview-value  saf-td-center'}>
                {props.itemData?.eccNumber}
              </div>
              <div className={'preview-col preview-label saf-bg-white'}>PTW Number</div>
              <div className={'preview-col preview-value  saf-td-center'}>
                {props.itemData?.ptwNo}
              </div>
            </div>
          )}

          {formInfo?.sections?.map((section: any, si: number) => {
            //console.log(section.renderType, 1);
            var prevGroupLabels = [];
            if (section.renderType === 'LIST_GROUP') {
              for (var i in section.items) {
                var item = section.items[i];
                if (prevGroupLabels.indexOf(item.groupLabel) === -1) {
                  prevGroupLabels.push(item.groupLabel);
                }
              }
              //console.log(prevGroupLabels);
            }
            var sectionAddClass = '';
            if (
              props.formCode === 'LP' &&
              section.renderType.indexOf('BASE') === -1 &&
              section.renderType.indexOf('APPR') === -1
            ) {
              sectionAddClass += ' half saf-area-01';
            }

            return (
              <Fragment key={si}>
                {props.formCode === 'LP' && si == 1 && (
                  <div className={'preview-section ' + sectionAddClass}>
                    <div className={'preview-image-01'}>
                      <img src={'/assets/image/ptw/ptw-preview-01.png'} />
                    </div>
                  </div>
                )}
                <div className={'preview-section ' + sectionAddClass}>
                  {/* section title */}
                  {!section?.hideLabel && (
                    <div
                      className={'preview-section-title '}
                      style={{ backgroundColor: section?.color01 }}
                    >
                      <div className={'preview-section-ynnar-t'}>
                        <div>
                          {!section?.hideNum && <>Section {si + 1} - </>}
                          {section.label}
                        </div>
                        {section.caption && (
                          <div className={'preview-section-caption'}>
                            <span>{section.caption}</span>
                          </div>
                        )}
                      </div>
                      {section.renderType.indexOf('LIST_YNNAR') > -1 && (
                        <Fragment>
                          <div className={'preview-section-ynnar-y'}>Yes</div>
                          <div className={'preview-section-ynnar-n'}>No</div>
                          <div className={'preview-section-ynnar-na'}>N/A</div>
                          <div className={'preview-section-ynnar-r'}>Remarks</div>
                        </Fragment>
                      )}
                    </div>
                  )}
                  {/* section contents */}
                  <div className={'preview-section-contents'}>
                    {section.renderType.indexOf('BASE01') > -1 && (
                      <PermitIssuePreviewBase01 section={section} data={props.itemData} />
                    )}
                    {section.renderType.indexOf('BASE02') > -1 && (
                      <PermitIssuePreviewBase02 section={section} data={props.itemData} />
                    )}
                    {section.renderType.indexOf('BASE04') > -1 && (
                      <PermitIssuePreviewBase04 section={section} data={props.itemData} />
                    )}
                    {section.renderType.indexOf('BASE05') > -1 && (
                      <PermitIssuePreviewBase05 section={section} data={props.itemData} />
                    )}
                    {section.renderType.indexOf('BASE06') > -1 && (
                      <PermitIssuePreviewBase06 section={section} data={props.itemData} />
                    )}
                    {section.renderType.indexOf('CHECK06') > -1 && (
                      <PermitIssuePreviewCheck06 section={section} data={props.itemData} />
                    )}
                    {section.renderType.indexOf('CHECK07') > -1 && (
                      <PermitIssuePreviewCheck07 section={section} data={props.itemData} />
                    )}
                    {section.renderType.indexOf('CHECK08') > -1 && (
                      <PermitIssuePreviewCheck08 section={section} data={props.itemData} />
                    )}

                    {section.renderType.indexOf('GRID') > -1 && (
                      <div className={'preview-flow-area'}>
                        {section.items?.map((item: any, ii: number) => {
                          return (
                            <div className={'preview-item-check-group'} key={ii}>
                              <input
                                type={'checkbox'}
                                readOnly={true}
                                checked={
                                  props.itemData &&
                                  props.itemData.formData &&
                                  props.itemData.formData[item.itemName]
                                    ? props.itemData.formData[item.itemName]
                                    : false
                                }
                              />
                              <label>{item.label}</label>
                              {item.type === 'CHECKBOX_TEXT' && (
                                <span className={'preview-item-check-add'}>
                                  &nbsp;&nbsp;(
                                  {props.itemData &&
                                  props.itemData.formData &&
                                  props.itemData.formData[item.itemName + '-REMARKS']
                                    ? props.itemData.formData[item.itemName + '-REMARKS']
                                    : '___'}
                                  )
                                </span>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                    {section.renderType.indexOf('LIST_YNNAR') > -1 && (
                      <PermitIssuePreviewListYnnar section={section} data={props.itemData} />
                    )}
                    {section.renderType.indexOf('LIST_GROUP') > -1 && (
                      <div className={'preview-list-area'}>
                        {prevGroupLabels?.map((groupLabel: any, gi: number) => (
                          <div className={'preview-list-area-group'} key={gi}>
                            <div className={'preview-group-label'}>{groupLabel} :</div>
                            <div className={'preview-group-items'}>
                              {section.items?.map((item: any, ii: number) => {
                                if (item.groupLabel === groupLabel) {
                                  return (
                                    <div className={'preview-group-item'} key={ii}>
                                      <input
                                        type={'checkbox'}
                                        readOnly={true}
                                        checked={
                                          props.itemData &&
                                          props.itemData.formData &&
                                          props.itemData.formData[item.itemName]
                                            ? props.itemData.formData[item.itemName]
                                            : false
                                        }
                                      />
                                      <label>{item.label}</label>
                                      {item.type === 'CHECKBOX_TEXT' && (
                                        <span className={'preview-item-check-add'}>
                                          &nbsp;&nbsp;(
                                          {props.itemData &&
                                          props.itemData.formData &&
                                          props.itemData.formData[item.itemName + '-REMARKS']
                                            ? props.itemData.formData[item.itemName + '-REMARKS']
                                            : '___'}
                                          )
                                        </span>
                                      )}
                                    </div>
                                  );
                                } else {
                                  return null;
                                }
                              })}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {section.renderType.indexOf('LIST_UNIT') > -1 && (
                      <PermitIssuePreviewListUnit section={section} />
                    )}
                    {section.renderType.indexOf('APPR01') > -1 && (
                      <PermitIssuePreviewApproval01
                        itemData={{
                          ...props.itemData,
                          approvalMVOList: approvalList
                        }}
                        formCode={props.formCode}
                      />
                    )}
                    {section.renderType.indexOf('APPR02') > -1 && (
                      <PermitIssuePreviewApproval02
                        itemData={{
                          ...props.itemData,
                          approvalMVOList: approvalList
                        }}
                        formCode={props.formCode}
                      />
                    )}
                    {section.renderType.indexOf('APPR03') > -1 && (
                      <PermitIssuePreviewApproval03
                        itemData={{
                          ...props.itemData,
                          approvalMVOList: approvalList
                        }}
                        formCode={props.formCode}
                      />
                    )}
                    {section.renderType.indexOf('APPR06') > -1 && (
                      <PermitIssuePreviewApproval06
                        itemData={{
                          ...props.itemData,
                          approvalMVOList: approvalList
                        }}
                        formCode={props.formCode}
                      />
                    )}
                    {section.renderType.indexOf('APPR07') > -1 && (
                      <PermitIssuePreviewApproval07
                        itemData={{
                          ...props.itemData,
                          approvalMVOList: approvalList
                        }}
                        formCode={props.formCode}
                      />
                    )}
                    {section.renderType.indexOf('APPR08') > -1 && (
                      <PermitIssuePreviewApproval08
                        itemData={{
                          ...props.itemData,
                          approvalMVOList: approvalList
                        }}
                        formCode={props.formCode}
                      />
                    )}
                    {section.renderType.indexOf('CLOSE01') > -1 && (
                      <PermitIssuePreviewClose01
                        itemData={{
                          ...props.itemData,
                          approvalMVOList: approvalList
                        }}
                        formCode={props.formCode}
                      />
                    )}
                  </div>
                </div>
              </Fragment>
            );
          })}
          {formInfo?.remark && (
            <div className={'preview-section'}>
              <div className={'saf-border-bottom-none preview-remark-area'}>
                <div className={'preview-text-03'}>Remark</div>
                <pre className={'saf-min-h50'}>{formInfo.remark}</pre>
              </div>
            </div>
          )}
          <div className={'preview-section'}></div>
        </div>
      </div>
    </div>
  );
};

export default PermitIssuePreview;
